import { DOUBLE_HYPHEN_BULLET } from '@/shared/config';
import { gettextSymptoms } from '@/shared/lib';
import { t } from 'ttag';

/**
 * Renders a symptom value for the study management ECG selection info panel. Maps the sentinel None onto a localized Not specified label, otherwise returns the translated symptom or the double-hyphen bullet placeholder.
 *
 * @param symptoms - Raw symptom value recorded on the study.
 * @returns The display text for the symptom.
 */
const symptomsFormatter = (symptoms: any) =>
  symptoms === 'None' ? t`Not specified` : gettextSymptoms(symptoms) || DOUBLE_HYPHEN_BULLET;

export { symptomsFormatter };
